// extracted by mini-css-extract-plugin
export var products__slider = "products-module--products__slider--2YAIq";
export var products__sliderContainer = "products-module--products__slider-container--vpTOn";
export var products__sliderPagination = "products-module--products__slider-pagination--DzTuK";